import { connect } from '@vfde-fe/sails_core';
import { createStructuredSelector } from 'reselect';
import mountOptionPicker, { updateOptionPicker } from '../../components/optionPicker';
import { selectError, selectSalesChannel, selectSelectedOption, selectTariffs } from 'Container/App/selector';
import { selectOption } from '../App/action';
import { areArraysEqual, areIdsNotEqual } from '../../helper/validator';
import { HtmlId } from '../App/enum';
import { toggleQualitySeal } from '../../components/qualitySeal';
import { mountJustText } from '../../components/justText';

const mapStateToProps = createStructuredSelector({
    salesChannel: selectSalesChannel,
    selectedOption: selectSelectedOption,
    tariffs: selectTariffs,
    error: selectError,
});

const mapDispatch = {
    selectOption,
};

type State = ReturnType<typeof mapStateToProps>;
type Actions = typeof mapDispatch;

/**
 * ProductSelection function
 */
function ProductSelection (state: State, actions: Actions) {
    const pickerHandler = (id: string) => actions.selectOption(undefined, id);

    const hardwareInfoHintComp = mountJustText(HtmlId.HARDWARE_HINT);
    const optionPickerComponent = mountOptionPicker(HtmlId.HARDWARE_PICKER, pickerHandler);

    return {
        getDerivedStateFromProps (newState: State, oldState: State) {
            if (newState.error) {
                return;
            }

            const { hardwareId, subscriptionId } = newState.selectedOption;
            const {
                hardwareId: oldHardwareId,
                subscriptionId: oldSubscriptionId,
            } = oldState.selectedOption;

            const hardwareChanged = areIdsNotEqual(hardwareId, oldHardwareId);
            const tariffChanged = areIdsNotEqual(subscriptionId, oldSubscriptionId);
            const salesChanged = newState.salesChannel !== oldState.salesChannel;
            const tariffsChanged = !areArraysEqual(newState.tariffs, oldState.tariffs);

            if (tariffChanged || hardwareChanged || salesChanged || tariffsChanged) {
                updateOptionPicker(
                    optionPickerComponent,
                    hardwareInfoHintComp,
                    newState.tariffs,
                    newState.selectedOption,
                    newState.salesChannel
                );
            }

            hardwareChanged && toggleQualitySeal(hardwareId);
        },
    };
}

const productSelection = connect(mapStateToProps, mapDispatch)(ProductSelection);

export default productSelection;
